import { Staff } from '../../models/Entities/Staff/Staff';
import { StaffFilter } from '../../models/Entities/Staff/StaffCommands';
import { PaginationState } from '../../models/PaginationState';
import { CommonState } from '../common/state/commonState';

export interface StaffState extends CommonState<Staff> {
  /** Criterio con el que se trajo la página que está en `list`. */
  filter: StaffFilter | undefined;

  /**
   * Paginación del servidor. La búsqueda y el corte los resuelve la API, así que
   * el total de registros no se puede deducir de `list`: lo que hay en memoria es
   * una página, no el universo.
   */
  pagination: PaginationState;

  /** Id devuelto por la última alta, para quien necesite saber cuál se creó. */
  lastCreatedId?: number;
}

export const StaffUnloadState: StaffState = {
  isLoadingAll: false,
  successLoadingAll: undefined,
  failOnLoadingAll: false,

  isLoadingOne: false,
  successLoadingOne: undefined,
  failOnLoadingOne: false,

  isAddingNewOne: false,
  successAddingNewOne: undefined,
  failOnAddingNewOne: false,

  isUpdatingOne: false,
  successUpdatingOne: undefined,
  failOnUpdatingOne: false,

  isDeletingOne: false,
  successDeletingOne: undefined,
  failOnDeletingOne: false,

  filter: undefined,
  pagination: {
    pageNumber: 1,
    pageSize: 20,
    totalPages: 0,
    totalRecords: 0
  },
  list: [],
  error: undefined,
  lastCreatedId: undefined
};
